<template>
    <div v-if="showTeamChangeModal" class="modal is-active">
        <div class="modal-background" @click="showTeamChangeModal = false"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Team Updated</p>
                <button class="delete" aria-label="close" @click="showTeamChangeModal = false"></button>
            </header>
            <section class="modal-card-body">
                <p class="has-text-grey mb-5">Your team assignment has been updated by the admin.</p>
                <div class="team-change-row">
                    <div class="team-change-box has-text-grey-light">
                        <p class="team-change-label">From</p>
                        <p class="team-change-name">{{ teamChangedFrom }}</p>
                    </div>
                    <span class="team-change-arrow">
                        <i class="fas fa-arrow-right"></i>
                    </span>
                    <div class="team-change-box is-primary-box">
                        <p class="team-change-label">To</p>
                        <p class="team-change-name">{{ teamChangedTo }}</p>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" @click="showTeamChangeModal = false">Got it</button>
            </footer>
        </div>
    </div>

    <base-spinner v-if="isLoading"></base-spinner>

    <div v-if="!!error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>

    <div v-if="volunteerData">
        <div v-if="isDeliveryTeam">

            <TeamInfo :fdID="currentFD.id" :team="volunteerData.team"></TeamInfo>

            <div v-if="!deliveries?.length && !isLoading" class="notification is-warning">
                No deliveries found for the team '{{ volunteerData.team }}'
            </div>

            <DeliveryItem v-for="delivery in deliveries" :key="delivery.id" :name="delivery.full_name"
                :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
                :street="delivery.street" :completed="delivery.completed" :completedAtTime="delivery.completed_at_time"
                :age="delivery.age" :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id"
                :fdID="currentFD.id" :fdStatus="currentFD.status" :status="delivery.status"
                :selfCollection="delivery.self_collection" :drivingDelivery="delivery.driving_delivery"
                :deliveryNotes="delivery.notes" :bagStatus="delivery.bag_status" :dietaryRequirement="delivery.dietary_requirement"
                :adminNotes="delivery.delivery_notes">
            </DeliveryItem>

        </div>

        <div v-else class="notification">
            <p class="title is-4">You are assigned to help at the Void Deck.</p>
        </div>

        <QuickReminders v-if="showIconGuide"></QuickReminders>
    </div>

    <div v-else class="notification">
        <p class="title is-4">You are not signed up for today's Food Distribution.</p>
        <p class="subtitle">Sign-up for this event has closed. Look out for future events at
            <router-link to="/volunteer">the volunteer page</router-link>.
        </p>
    </div>
</template>
<script>

import DeliveryItem from '@/components/delivery/DeliveryItem.vue';
import QuickReminders from '@/components/delivery/QuickReminders.vue';
import TeamInfo from '@/components/volunteer/TeamInfo.vue';

export default {
    components: {
        DeliveryItem,
        QuickReminders,
        TeamInfo
    },
    data() {
        return {
            isLoading: false,
            error: null,
            showIconGuide: false,
            showTeamChangeModal: false,
            teamChangedFrom: null,
            teamChangedTo: null,
        }
    },
    watch: {
        currentTeam: {
            immediate: true,
            handler(newTeam, oldTeam) {
                if (newTeam && newTeam !== oldTeam) {
                    if (oldTeam !== undefined && oldTeam !== null) {
                        this.teamChangedFrom = oldTeam;
                        this.teamChangedTo = newTeam;
                        this.showTeamChangeModal = true;
                    }
                    this.$store.dispatch('delivery/unsubDeliveries');
                    this.loadDeliveries();
                }
            }
        }
    },
    methods: {
        async loadDeliveries() {
            this.isLoading = true;
            if (this.isDeliveryTeam) {
                try {
                    await this.$store.dispatch('delivery/getDeliveriesForTeam', {
                        fdID: this.currentFD.id,
                        fdTeam: this.volunteerData.team
                    });
                } catch (error) {
                    this.error = error.message || 'Something went wrong!';
                }
                this.showIconGuide = true;
            }
            this.isLoading = false;
        }
    },
    computed: {
        currentTeam() {
            return this.volunteerData?.team ?? null;
        },
        isDeliveryTeam() {
            const team = this.volunteerData?.team;
            return !!team && team !== 'void_deck';
        },
        deliveries() {
            return this.$store.getters['delivery/getDeliveries'];
        },
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        },
        volunteerData() {
            return this.$store.getters['volunteer/getVolunteerData'];
        }
    },
    unmounted() {
        this.$store.dispatch('delivery/unsubDeliveries');
    }
}

</script>

<style scoped>
.team-change-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
}

.team-change-box {
    flex: 1;
    text-align: center;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
}

.team-change-box.is-primary-box {
    background: #ebfaf7;
    border-color: #00d1b2;
}

.team-change-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #aaa;
    margin-bottom: 0.25rem;
}

.team-change-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #363636;
}

.team-change-box.is-primary-box .team-change-name {
    color: #00947e;
}

.team-change-arrow {
    color: #b5b5b5;
    font-size: 1.1rem;
    flex-shrink: 0;
}
</style>